var map = {
	"./decidim/avatar-multiuser.png": 9044,
	"./decidim/brands/facebook.svg": 84250,
	"./decidim/brands/google.svg": 98331,
	"./decidim/brands/twitter-x.svg": 42088,
	"./decidim/cc-badge.png": 39094,
	"./decidim/decidim-logo.svg": 39542,
	"./decidim/default-avatar.svg": 70130,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 94742,
	"./decidim/icons.svg": 42533,
	"./decidim/pattern.png": 35090,
	"./decidim/placeholder-card-g.svg": 38303,
	"./decidim/placeholder-card-l.svg": 18564,
	"./decidim/placeholder.jpg": 47259,
	"./decidim/remixicon.symbol.svg": 35667,
	"./decidim/vendor/social-share-button/douban.svg": 32514,
	"./decidim/vendor/social-share-button/email.svg": 58591,
	"./decidim/vendor/social-share-button/facebook.svg": 18177,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 13395,
	"./decidim/vendor/social-share-button/hacker_news.svg": 91539,
	"./decidim/vendor/social-share-button/linkedin.svg": 3055,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 70280,
	"./decidim/vendor/social-share-button/pinterest.svg": 63377,
	"./decidim/vendor/social-share-button/reddit.svg": 69601,
	"./decidim/vendor/social-share-button/telegram.svg": 66040,
	"./decidim/vendor/social-share-button/tumblr.svg": 67695,
	"./decidim/vendor/social-share-button/twitter.svg": 79182,
	"./decidim/vendor/social-share-button/vkontakte.svg": 28592,
	"./decidim/vendor/social-share-button/wechat.svg": 52539,
	"./decidim/vendor/social-share-button/whatsapp.svg": 88275,
	"./decidim/vendor/social-share-button/x.svg": 2391,
	"./decidim/vendor/social-share-button/xing.svg": 81985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34667;